module.exports = __webpack_public_path__ + "static/scale-model-of-escape-gate-in-provo-utah-e9a67e32d71c13a8939072c3d7e8e728.png";